import { create } from 'zustand';

interface FeatureFlagsState {
  enabledFlags: string[];
  setEnabledFlags: (flags: string[]) => void;
  clearFlags: () => void;
  isEnabled: (key: string) => boolean;
}

/**
 * Feature flags store
 * No persistence - flags are loaded fresh on each login
 * Flags are loaded by usePostLoginInit based on user's workspace
 */
export const useFeatureFlagsStore = create<FeatureFlagsState>((set, get) => ({
  enabledFlags: [],

  /**
   * Set the list of enabled feature flag keys
   */
  setEnabledFlags: (flags) => set({ enabledFlags: flags }),

  /**
   * Clear all flags (called on logout)
   */
  clearFlags: () => set({ enabledFlags: [] }),

  /**
   * Check if a specific feature flag is enabled
   */
  isEnabled: (key) => get().enabledFlags.includes(key),
}));
